<template>
  <div class="text-center z5">
    <v-card width="1400">
      <v-row no-gutters>
        <v-col cols="12">
          <v-divider />
          <v-card-text class="pa-0">
            <ParticipantHorseList v-if="computedSession" :session.sync="computedSession" />
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { computed, onBeforeMount } from '@vue/composition-api';

import ParticipantHorseList from '../ParticipantHorse/ParticipantHorseList.vue';

import store from '@/store';

export default {
  components: { ParticipantHorseList },
  props: {
    session: {
      type: Object,
      default: null
    }
  },
  setup (props) {
    const sessions = computed(() => store.getters.dailySessions);

    const computedSession = computed(() => {
      if (props.session) {
        const sessionBody = { ...sessions.value.find(s => s.uuid === props.session.uuid) };
        if (sessionBody && !sessionBody.horses) {
          sessionBody.horses = [];
        }
        if (sessionBody && !sessionBody.participants) {
          sessionBody.participants = [];
        }
        return sessionBody;
      }
      return null;
    });

    return { computedSession };
  }
};
</script>

<style>
  .horseList:hover {
    background-color: #f5f4f4;
  }
</style>
